import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { CountUpModule } from 'ngx-countup';
import { ReportsModule } from '../reports/reports.module';
import { CustomerListComponent } from './components/customer-list/customer-list.component';
import { CustomerViewComponent } from './components/customer-view/customer-view.component';
import { AddReportDialogComponent } from './components/dialogs/add-report/add-report.dialog';
import { CustomersRoutingModule } from './customers.routing.module';
import { CustomerLongnamePipe } from './pipes/customer-longname.pipe';
import { CustomerService } from './services/customer.service';

@NgModule({
	declarations: [CustomerListComponent, CustomerViewComponent, CustomerLongnamePipe, AddReportDialogComponent],
	exports: [CustomerListComponent, CustomerViewComponent, CustomerLongnamePipe, AddReportDialogComponent],
	imports: [
		CommonModule,
		CountUpModule,
		FlexLayoutModule,
		FormsModule,
		MatButtonModule,
		MatCardModule,
		MatDialogModule,
		MatDividerModule,
		MatProgressSpinnerModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule,
		MatCheckboxModule,
		MatListModule,
		MatRadioModule,
		MatSelectModule,
		MatTableModule,
		MatTreeModule,
		MatTreeModule,
		MatTooltipModule,
		MatStepperModule,
		ReactiveFormsModule,
		ReportsModule,
		CustomersRoutingModule
	]
})
export class CustomersModule {
	static forRoot(): ModuleWithProviders<CustomersModule> {
		return {
			ngModule: CustomersModule,
			providers: [{ provide: CustomerService }]
		};
	}
}
